import { mapActions, mapGetters } from 'vuex'
import goToPage from '@/mixins/goToPageMixin'
import productPlaceComponentMixin from '@/mixins/productPlaceComponentMixin'
import gcsReplayRecordMixin from '@/mixins/gcsReplayRecordMixin'
import { GetProjectInfo, NavigateToBrowser as NavigateToBrowserFromGcs, RecordJournal } from '@/core/gcsUtils'
export default {
  mixins: [goToPage, productPlaceComponentMixin, gcsReplayRecordMixin],
  data() {
    return {
      resourceLoading: false,
      saveAsPath: ''
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      project: 'selectionList/project',
      shareDefinitions: 'shareParams/shareDefinitions',
    }),
    showPlaceComp() {
      return this.platform === 'r' || this.platform === 'g' || this.platform === 'cs'
    },
    showPlaceCompG() {
      return this.platform === 'g'
    },
    showPlaceCompWeb() {
      return this.platform === 'web'
    },
    searchWithCurveProperties() {
      return this.curveProperties && this.curveProperties.length && this.curveProperties.some((c) => c.value)
    },
  },
  mounted() {
    // 进入页面，返回actionResult，结束回放
    window.replayProductListCallback && window.replayProductListCallback()
  },
  methods: {
    ...mapActions({
      loadDefinitions: 'shareParams/loadDefinitions',
      loadAggProductSeries: 'list/loadAggProductSeries',
    }),
    // 插件端获取项目信息
    async getProjectInfo() {
      let projectInfo = {}
      if (this.platform === 'g') {
        const { data } = await GetProjectInfo()
        projectInfo = data || {}
      } else if (this.platform === 'r') {
        const { data } = await this.$revitClient.GetProjectInfo()
        projectInfo = data || {}
      }
      return projectInfo
    },
    // 查看产品详情页
    toDetail(row) {
      const designProperties = this.getDesignProperties(row)
      let query = { designProperties: JSON.stringify(designProperties) }
      if (this.brandCode) {
        query = { ...query, brandCode: this.brandCode }
      }
      const routeInfo = {
        name: 'ProductDetail',
        params: { id: row.id },
        query
      }
      RecordJournal('GoToProductDetailPage', routeInfo)
      this.toPage(routeInfo)
    },
    // 获取产品关联的构件资源列表
    async getProductComponents(productId) {
      const query = this.platform !== 'web'
        ? this.platform === 'cs' ? { software_code: 'AppGmep', software_version: this.softwareVersion }
          : { software_code: this.softwareCode, software_version: this.softwareVersion }
        : {}
      const data = await this.$api.products.relatedComponents(productId, query)
      return data && data.length ? data.map((item) => {
        item.type = 'comp'
        return item
      }) : []
    },
    // 获取产品关联的图块资源列表
    async getProductBlocks(productId) {
      const data = await this.$api.products.relatedBlocks(productId)
      return data && data.length ? data.map((item) => {
        item.type = 'block'
        return item
      }) : []
    },
    // 根据平台处理产品管理资源列表
    async handleResource(productId) {
      let components = []
      let blocks = []
      if (this.platform === 'web') {
        const [componentsRes, blocksRes] = await Promise.all([this.getProductComponents(productId), this.getProductBlocks(productId)])
        components = componentsRes
        blocks = blocksRes
      } else {
        components = await this.getProductComponents(productId)
      }
      return [...components, ...blocks]
    },

    // 显示资源popover
    async showPopover(row) {
      // 如果该行已经有资源相关的数据，无需重新请求，直接展示
      if (row.resource) { return }
      this.resourceLoading = true
      try {
        row.resource = await this.handleResource(row.id)
      } finally {
        this.resourceLoading = false
      }
    },

    // 选中产品
    async handleSelectProduct(payload) {
      try {
        const data = payload
        if (data) {
          if (data.designProperties) {
            data.designProperties.forEach((i) => { i.type = 'design' })
          }
          if (data.runtimeProperties) {
            data.runtimeProperties.forEach((i) => { i.type = 'runtime' })
          }
        }
        await this.$api.project.selectProduct(this.project.id, data)
        this.$message.success('已选中，可在“已选产品”中查看')
      } catch (err) {
        this.$message.error('选中失败，请稍后重试')
        console.error(err)
      }
    },
    // 选中产品埋点
    selectTrack(payload) {
      this.$tracks({
        event: 'productSelect',
        params: {
          g_c_product_id: payload.productId,
          g_c_class_code: payload.gjwCategoryCode,
          g_c_class_name: payload.gjwCategoryName,
          g_c_selection_project_id: this.project.id,
          g_c_source: payload.source,
        }
      })
    },
    // 反馈
    async toFeedback() {
      const url = this.selectedBrandUrl || encodeURI(`${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?from=6&source=Selection`)
      if (this.platform === 'r') {
        this.$revitClient.NavigateToBrowser(url)
      } else if (this.platform === 'g') {
        await NavigateToBrowserFromGcs(url)
      } else {
        window.open(url, '_blank')
      }
    },

    async toPlaceComponent(row) {
      this.$fullLoading.open()
      const isLog = await this.checkLogin()
      if (!isLog) {
        this.$fullLoading.close()
        return
      }
      if (!row.resource) {
        row.resource = await this.handleResource(row.id)
      }
      if (row.resource && row.resource.length) {
        const comp = row.resource[0]
        const designProperties = this.getDesignProperties(row, true)
        const runtimeProperties = this.getRunTimeProperties(row, true)
        const trackPartParams = {
          g_c_product_id: this.productId,
          g_c_source: 'selection',
        }
        try {
          if (this.platform === 'r') {
            const payload = {
              productId: row.id,
              publicComponentId: comp.id,
              softwareCode: this.softwareCode,
              softwareVersion: this.softwareVersion,
            }
            const rPayload = {
              payload,
              designValue: designProperties,
              trackPartParams,
            }
            await this.placeRevitComponent(rPayload)
          } else if (this.platform === 'g') {
            const payload = {
              productId: row.id,
              publicComponentId: comp.id,
              digitalComponentId: comp.coreResourceVersionId,
              equipmentNum: null,
              powerConsumptionPerAirVolume: row.powerConsumptionPerAirVolume || null,
              designProperties,
              runtimeProperties,
            }
            const gPayload = { payload, trackPartParams, recordMethodName: 'PlacePublicComponentFromProductsList' }
            await this.placeGcsComponent(gPayload)
          } else if (this.platform === 'cs') {
            if (row.resource && row.resource.length > 0) {
              await this.placeCSComponent(row.resource[0])
            } else {
              this.$message.error('无可布置的构件...')
              return
            }
          }
        } finally {
          this.$fullLoading.close()
        }
      } else {
        this.$fullLoading.close()
        this.$confirm('暂无可用资源，我们将联系厂商尽快提供，请通过“反馈”或“广小二”联系官方客服。', '布置失败', {
          type: 'warning',
          showCancelButton: false,
        }).then().catch()
      }
    },
  },
}
